// @ts-nocheck
/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react';
// import { Helmet, HelmetProvider } from 'react-helmet-async';
import { connect } from 'react-redux';

// react library for routing
import {
  BrowserRouter, Route, Switch, Redirect
} from 'react-router-dom';

// plugins styles from node_modules
import 'react-notification-alert/dist/animate.css';
import 'react-perfect-scrollbar/dist/css/styles.css';
import '@fullcalendar/common/main.min.css';
import '@fullcalendar/daygrid/main.min.css';
import 'sweetalert2/dist/sweetalert2.min.css';
import 'select2/dist/css/select2.min.css';
import 'quill/dist/quill.core.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

// plugins styles downloaded
import 'assets/vendor/nucleo/css/nucleo.css';

// core styles
import 'assets/scss/argon-dashboard-pro-react.scss?v1.2.0';

// Layouts
import RTLLayout from './layouts/RTL';
import AuthLayout from './layouts/Auth';
import AdminLayout from './layouts/Admin';

export default function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route
          path="/admin"
          render={(props) => <AdminLayout {...props} />}
        />
        <Route
          path="/rtl"
          render={(props) => <RTLLayout {...props} />}
        />
        <Route path="/" render={(props) => <AuthLayout {...props} />} />
        <Redirect from="*" to="/" />
      </Switch>
    </BrowserRouter>
  );
}
